import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import equal from "fast-deep-equal";

import * as homeReducer from "containers/Home/reducer";
import * as nextReducer from "containers/Next/NextReducer";

import Blueprint from "components/Next/Blueprint/Blueprint";

const getId = (props) =>
  props && props.blueprintId
    ? props.blueprintId
    : props && props.match && props.match.params && props.match.params.blueprintId
      ? props.match.params.blueprintId
      : "new";

class BlueprintContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { id } = this.props;

    return <Blueprint {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getId(ownPropspp);

  return {
    replayActions: (stopNode) => dispatch(nextReducer.replayActions(id, stopNode))
  };
};
const mapStateToProps = (state, ownProps) => {
  const id = getId(ownPropspp);

  return {
    id: id
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(BlueprintContainer);
